import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ValidarTokenGuard  {

  constructor(private authService: AuthService, private router: Router){

  }
  canLoad(route: Route, segments: import("@angular/router").UrlSegment[]): Observable<boolean> |  boolean  | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    
    return this.authService.validarToken().pipe(
      map((valid) => valid ? true : this.router.createUrlTree(['/login']))
    );
  }
  canActivate( next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
   
    return this.authService.validarToken().pipe(
      map((valid) => valid ? true : this.router.createUrlTree(['/login']))
    );
  }
 
}
